import { MailClient } from '../components/MailClient.jsx';

export function AdminEmailsPage() {
  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Emails</h2>
      <p className="muted small mail-page-intro">
        Your Outlook mailbox. Read, reply, forward, and send without leaving the portal.
      </p>
      <MailClient />
    </div>
  );
}
